export const apiCacheDuration = 30 * 1000;
export const apiPrefix = '/api/v1';
// export const appUrl = 'https://app.swool.io';
// export const apiDomain = 'https://poetic-unconstructively-fatima.ngrok-free.dev';
// export const apiDomain = 'https://api.swool.haf';
export const apiDomain = 'https://swapi.swool.io';
export const apiUrl = apiDomain + apiPrefix;
